<template>
    <v-card class="mb-12">
        <v-card-title class="px-8">
            <v-row>
                <v-col>
                    Performance Details
                </v-col>
            </v-row>
        </v-card-title>
        <v-simple-table dense v-if="performance !== null" class="account-table">
            <template v-slot:default>
            <thead>
            <tr>
                <th>
                    Account
                </th>
                <th>
                    Account Number
                </th>
                <th>
                    Open Date
                </th>
                <th>
                    Market Value to {{ performance.endDate }}
                </th>
                <th>
                    {{ performance.beginDate }}
                    <br>to {{ performance.endDate }}
                </th>
                <th>
                    MTD to {{ performance.endDate }}
                </th>
                <th>
                    QTD to {{ performance.endDate }}
                </th>
                <th>
                    YTD to {{ performance.endDate }}
                </th>
                <th>
                    Since Inception
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="performance.householdPerformance !== null" class="gray-line">
              <td colspan="3">{{ performance.householdPerformance.name }}</td>
              <td>{{ performance.sum | money }}</td>
              <template v-for="(key, keyIndex) in performance.householdPerformance.performances">
                <td :key="keyIndex" v-if="keyIndex != 5">{{ key | percentage }}</td>
              </template>
            </tr>
            <template>
                <tr v-for="(row, index) in performance.rows" :key="index" >
                    <td>{{ row.name }}</td>
                    <td>{{ row.number }}</td>
                    <td>{{ row.open_date }}</td>
                    <td>{{ row.market_value | money }}</td>
                    <template v-for="(key, keyIndex) in performance.keys">
                        <td :key="keyIndex" v-if="keyIndex != 5">{{ row.performances[key] | percentage }}</td>
                    </template>
                </tr>
            </template>
            </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "YearToDateTable",
    computed: mapState({
        performance: state => state.household.performance,
    }),
}
</script>

<style lang="scss">

    .account-table th {
        height: 90px !important;
        color: #FFF !important;
        text-transform: uppercase;
        font-weight: 500;
        background-color: #1D5BE5;
    }

    .account-table td {
        padding: 16px !important;
        font-size: 0.8rem !important;
    }

    .gray-line {
        background-color: #dbdbdb;
    }

</style>
